import { supabase } from "@/integrations/supabase/client";
import { debugLog } from "@/services/errorLogger";

/**
 * Métriques de lecture vidéo.
 *
 * Pourquoi : le démarrage d'une vidéo est le principal indicateur de performance
 * perçue du feed. On mesure le délai entre l'activation d'une vidéo et le premier
 * frame joué afin de pouvoir comparer objectivement les optimisations
 * (poster, préchargement, pagination, futur streaming adaptatif).
 */
export const VIDEO_START_METRIC = "video_start";

/**
 * Enregistre le temps de démarrage d'une vidéo (en millisecondes).
 * Les échecs sont silencieux : une métrique ne doit jamais casser la lecture.
 */
export async function logVideoStartTime(
  durationMs: number,
  videoId: string,
  page: string = "feed"
): Promise<void> {
  // Garde-fou : ignorer les valeurs aberrantes (onglet en arrière-plan, etc.)
  if (!Number.isFinite(durationMs) || durationMs < 0 || durationMs > 60_000) return;

  try {
    // Session lue localement : aucun appel réseau à chaque démarrage.
    const {
      data: { session },
    } = await supabase.auth.getSession();
    const user = session?.user ?? null;

    await supabase.from("performance_metrics").insert({
      metric_type: VIDEO_START_METRIC,
      value: Math.round(durationMs),
      page,
      user_id: user?.id ?? null,
      metadata: { video_id: videoId },
    });
  } catch (error) {
    debugLog("VIDEO", "Failed to log video start metric", error);
  }
}
